export const DealerStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  BLOCKED: 'BLOCKED',
  BLOCKED_DUE_TO_PAYMENT: 'BLOCKED_DUE_TO_PAYMENT',
  REJECTED: 'REJECTED',
};

export const DealerStatusName = {
  ACTIVE: 'Active',
  PENDING: 'Pending',
  BLOCKED: 'Archived',
  BLOCKED_DUE_TO_PAYMENT: 'Blocked due to payment',
  REJECTED: 'Rejected',
};

export const DealerStatusActionName = {
  ACTIVATE: 'Activate',
  REJECT: 'Reject',
  BLOCK: 'Archive',
};
